if (!customElements.get('elix-product')) {
  class ElixProduct extends HTMLElement {}
  customElements.define('elix-product', ElixProduct)
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.elix-product').forEach((root) => {
    if (root.dataset.elixInitialized === 'true') return;
    root.dataset.elixInitialized = 'true';
    const mediaItems = root.querySelectorAll('.elix-gallery__media');
    root.querySelectorAll('[data-media-target]').forEach((thumb) => thumb.addEventListener('click', () => {
      mediaItems.forEach((item) => { item.classList.toggle('is-active', item.dataset.mediaId === thumb.dataset.mediaTarget); item.hidden = item.dataset.mediaId !== thumb.dataset.mediaTarget; });
      root.querySelectorAll('[data-media-target]').forEach((item) => { const active = item === thumb; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', active); });
    }));

    const form = root.querySelector('.elix-form');
    const variants = JSON.parse(root.querySelector('[data-elix-variants]')?.textContent || '[]');
    root.querySelectorAll('.elix-option').forEach((option) => option.addEventListener('click', () => {
      const fieldset = option.closest('fieldset');
      fieldset.querySelectorAll('.elix-option').forEach((item) => { const active = item === option; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', active); });
      const selected = [...root.querySelectorAll('.elix-options')].map((group) => group.querySelector('.elix-option.is-active')?.dataset.optionValue);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      form.querySelector('[data-variant-id]').value = variant.id;
      const price = root.querySelector('[data-elix-price]');
      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(variant.price / 100);
      const add = form.querySelector('[name="add"]'); add.disabled = !variant.available;
      if (variant.featured_media) root.querySelector(`[data-media-target="${variant.featured_media.id}"]`)?.click();
      const variantURL = new URL(location.href);
      variantURL.searchParams.set('variant', variant.id);
      history.replaceState({}, '', variantURL.pathname + variantURL.search + variantURL.hash);
    }));
    const quantity = form?.querySelector('[name="quantity"]');
    form?.querySelector('[data-qty-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value) - 1); });
    form?.querySelector('[data-qty-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value) + 1; });
    let submitting = false;
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[name="add"]');
      if (submitting || button.disabled) return;
      submitting = true;
      const message = form.querySelector('.elix-form-message');
      const strings = window.ElixCartAddStrings;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      message.replaceChildren();
      message.classList.remove('is-error');
      let added = false;
      try {
        const result = await window.ElixCartAdd.add(form, { cart });
        added = true;
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'elix-product', cartData: result });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (cart) cart.renderContents(result);
        message.textContent = strings.added;
      } catch (error) {
        message.textContent = added ? strings.cartRefreshError : (error.cartResponse ? error.message : strings.error);
        message.classList.add('is-error');
        const link = document.createElement('a');
        link.href = window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;
        link.textContent = strings.cartLink;
        message.append(' ', link);
      } finally {
        submitting = false;
        button.removeAttribute('aria-busy');
        const activeVariant = variants.find(item => String(item.id) === form.querySelector('[data-variant-id]').value);
        button.disabled = activeVariant ? !activeVariant.available : false;
      }
    });
  });
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: .08 });
  document.querySelectorAll('.elix-reveal').forEach((item) => observer.observe(item));
});
